import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Skeleton } from "primereact/skeleton";

export const SkeletonCards = () => {
  const skeletonCards = Array.from({ length: 5 }, (_, index) => (
    <Card className="card-project" key={index}>
      <div className="header">
        <Skeleton width="100%" height="20px" className="margin-bottom-2" />
      </div>
      <div className="sub-header">
        <Skeleton width="50%" height="16px" className="margin-bottom-2" />
      </div>
      <Divider />
      <div className="footer-card">
        <Skeleton width="100%" height="23px" />
      </div>
    </Card>
  ));
  return <div className="container-projects">{skeletonCards}</div>;
};
